import { Box, Button, Dialog, DialogActions, styled } from '@mui/material'
import { useCallback } from 'react'
import { DisplayPaymentType } from './PaymentSettingSelector'
import { IPaymentTypeSelection } from 'components/Sell/payment/hook/usePaymentContext'

interface IPaymentSettingSelectorDialog {
    paymentTypeSettings: IPaymentTypeSelection[]
    onClose: () => void
    onSelectPaymentType: (paymentSettingID: string) => void
    expectAmount: number
}

const MIN_HEIGHT = 55

const PaymentButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.topside.paper,
    '&:hover': {
        backgroundColor: theme.palette.topside.paper,
    },
    color: theme.palette.primary.main,
    minWidth: 240,
    minHeight: MIN_HEIGHT,
    borderColor: theme.palette.primary.main,
    border: '1px solid',
    boxShadow: 'none',
}))

function PaymentSettingSelectorDialog({
    paymentTypeSettings,
    onClose,
    onSelectPaymentType,
    expectAmount,
}: IPaymentSettingSelectorDialog) {
    const onClickPayment = useCallback(
        (paymentTypeID: string) => {
            onSelectPaymentType(paymentTypeID)
            onClose()
        },
        [onClose, onSelectPaymentType],
    )

    return (
        <Dialog open={true} onClose={onClose}>
            {paymentTypeSettings.map((i, index) => (
                <Box m={1} key={`payment-type-selection-dialog-${index}`}>
                    <PaymentButton
                        disabled={i.disabled(expectAmount)}
                        onClick={() => onClickPayment(i.paymentSettingID!)}
                    >
                        <DisplayPaymentType paymentSetting={i} />
                    </PaymentButton>
                </Box>
            ))}
            <DialogActions>
                <Button
                    fullWidth
                    color="primary"
                    sx={{ height: MIN_HEIGHT }}
                    onClick={onClose}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}
export default PaymentSettingSelectorDialog
